/** Tables that keep their own page/size in the URL, beside the plain `?page` /
 *  `?size` the roster tabs use. One entry per table that can share a view with
 *  another: the Shopify coupon sections and the two conversions scopes. */
export type PageNamespace =
  | 'sc_active'
  | 'sc_leftover'
  | 'sc_replaced'
  | 'sc_inactive'
  | 'sc_renamed'
  | 'cv_creator'
  | 'cv_campaign'
  | 'cv_refused';

export type PageParamKey =
  | 'page'
  | 'size'
  | `${PageNamespace}_page`
  | `${PageNamespace}_size`;

export function pageParamKey(namespace?: PageNamespace): PageParamKey {
  return namespace ? `${namespace}_page` : 'page';
}

export function sizeParamKey(namespace?: PageNamespace): PageParamKey {
  return namespace ? `${namespace}_size` : 'size';
}
